// We need to have some default prop values that are dependent on the element being in a browser context. This exports a hook which can be used in other components.
import { useState, useEffect } from "react";
export default (defaultHandler = x => x) => {
  const [propValue, setPropValue] = useState(null);
  useEffect(() => {
    setPropValue(defaultHandler());
  }, [defaultHandler]);
  return propValue;
};